import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxs};
    padding-bottom: ${theme.v3.spacing.xxl};
    width: 100%;
  `}
`;

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: ${theme.v3.spacing.xxs};
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const WhiteCard = styled.div`
  ${({ theme, $loading, $centerContent }) => css`
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.none};
    margin-top: ${theme.v3.spacing.nano};
    padding: ${theme.v3.spacing.xxs};
    width: 100%;
    
    ${$centerContent && css`
      align-items: center;
      display: flex;
      justify-content: center;
      padding: ${theme.v3.spacing.xxxl} !important;
    `}
      
    @media (min-width: ${theme.v3.breakpoints.sm}){
      border-radius: ${theme.v3.border.radius.round};
      padding: ${theme.v3.spacing.sm} ${theme.v3.spacing.xs};
    }

    ${$loading && css`
      display: flex;
      flex-direction: column;
      gap: ${theme.v3.spacing.xxxs};
    `}
  `}
`;

export const WhiteCardHeader = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.v3.spacing.xxxs};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      margin-bottom: ${theme.v3.spacing.xxs};
    }
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    line-height: ${theme.v3.font.lineHeight.compact};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes['2xlarge']};
    }
  `}
`;

export const WhiteCardContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.xxs};
  `}
`;

export const InnerCard = styled.div`
  ${({ theme }) => css`
    border-color: ${theme.v3.colors.neutral[98]};
    border-radius: ${theme.v3.border.radius.round};
    border-style: solid;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0px;
    flex-wrap: wrap;
    border-width: 0px;
    gap: ${theme.v3.spacing.xxxs};
    
    @media (min-width: ${theme.v3.breakpoints.sm}){
      padding: ${theme.v3.spacing.md} ${theme.v3.spacing.xl};
      border-width: ${theme.v3.border.width.thick};
      gap: ${theme.v3.spacing.xl};
    }
  `}
`;

export const InnerCardColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  display: flex;
  width: 100%;
  max-width: 100%;
`;

export const InnerCardColumnTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[30]};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    text-align: center;
  
    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes.huge};
      text-align: left;
    }
  `}
`;

export const InnerCardColumnList = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.v3.spacing.nano};
    list-style-type: none;
    margin: ${theme.v3.spacing.xxxs} 0px 0px 0px;
    padding: 0;
    text-align: center;

    svg {
      display: none;
    }
      
    @media (min-width: ${theme.v3.breakpoints.sm}){
      text-align: left;
      gap: ${theme.v3.spacing.xxxs};
      margin: ${theme.v3.spacing.xxs} 0px 0px 0px;
      
      svg {
        display: flex;
      }
    }
  `}
`;

export const InnerCardColumnListItem = styled.li`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v3.colors.neutral[40]};
    display: flex;
    font-size: ${theme.v3.font.sizes.xxs};
    font-weight: ${theme.v3.font.weights.regular};
    gap: ${theme.v3.spacing.xxxs};
    line-height: ${theme.v3.font.lineHeight.comfortable};

    @media (min-width: ${theme.v3.breakpoints.sm}){
      font-size: ${theme.v3.font.sizes['1xmedium']};
    }
  `}
`;

export const InnerCardButtonWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.v3.spacing.xs};

    button {
      width: 100%;
    }

    @media (min-width: ${theme.v3.breakpoints.sm}){
      button {
        width: fit-content;
      }    
    }
  `}
`;

export const ItemsRow = styled.div`
  ${({ theme, $flexDirection }) => css`
    display: flex;
    flex-direction: ${$flexDirection || 'row'};
    gap: ${theme.v3.spacing.xxxs};
    margin-top: ${theme.v3.spacing.xxs};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const CardItem = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    border-radius: ${theme.v3.border.radius.round};
    border: ${theme.v3.border.width.thin} solid ${theme.v3.colors.neutral[95]};
    display: flex;
    flex-direction: row;
    flex: auto;
    gap: ${theme.v3.spacing.nano};
    padding: ${theme.v3.spacing.xxs};
    width: 100%;
  `}
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: ${theme.v3.spacing.nano};
  `}
`;

export const CardTitle = styled(Title)`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    line-height: ${theme.v3.font.lineHeight.relaxed};
  `}
`;

export const CardDescription = styled(Title)`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.small};
    height: 41px;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-top: ${theme.v3.spacing.nano};
    font-weight: ${theme.v3.font.weights.regular};
    max-width: 393px;
  `}
`;

export const CardCtaWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.v3.spacing.xxxs};
  `}
`;

export const CardCtaColumn = styled.div`
  margin: auto;
  margin-right: 0;
`;

export const CarouselItem = styled.div`
  ${({ theme, $mobileFlexWrap }) => css`
    padding: ${theme.v3.spacing.xxs};
    border-radius: ${theme.v3.border.radius.round};
    border: ${theme.v3.border.width.medium} solid ${theme.v3.colors.neutral[98]};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.v3.spacing.xxxs};

    ${$mobileFlexWrap && css`
      @media (max-width: ${theme.v3.breakpoints.md}) {
        flex-wrap: wrap;
        justify-content: flex-start;
        max-width: 252px;
      }
    `}
  `}
`;

export const CarouselAccessButton = styled.div`
  ${({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const ColumnCarouselItem = styled(CarouselItem)`
  flex-direction: column;
  align-items: flex-start;
`;

export const ColumnCarouselItemTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.v3.spacing.nano};
`;

export const CarouselItemIconWrapper = styled.div`
  ${({ theme }) => css`
     display: flex;
     align-items: center;
     justify-content: center;
     background-color: ${theme.v3.colors.brand.snappyBlue[95]};
     border-radius: ${theme.v3.border.radius.circular};
     min-width: 40px;
     min-height: 40px;

     @media (max-width: ${theme.v3.breakpoints.md}) {
      min-width: 32px;
      min-height: 32px;
     }
  `}
`;

export const CarouselItemTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-size: ${theme.v3.font.sizes.large};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    min-width: fit-content;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;

export const CarouselRowItemTitle = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
  `}
`;

export const CarouselItemDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    max-width: 296px;
    min-width: unset;
  `}
`;

export const CarouselCtaWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.v3.spacing.xxl};
  `}
`;

export const SkeletonRow = styled.div`
  display: flex;
  width: 100%;
`;

export const SkeletonInline = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-wrap: wrap;
    }
  `}
`;
